import * as React from 'react';
import styled, { css } from 'styled-components';

import Description from 'report/common/Description';

const Container = styled.div`
  padding-top: 30%;
  min-height: 600px;
`;

const Headline = styled.h1(
  ({ theme }) => css`
    color: black !important;
    font-size: 2em;
    text-align: center;
    margin-bottom: ${theme.spacings.lg};
  `,
);

const Subheadline = styled.h2(
  ({ theme }) => css`
    color: #555 !important;
    font-size: 1.6em;
    text-align: center;
    margin-bottom: ${theme.spacings.lg};
  `,
);

const Tz = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.colors.text.secondary} !important;
  `,
);

type Props = {
  description: string;
  subtitle: string | undefined;
  title: string;
  tz: string;
};

const CoverPage = ({ title, description, subtitle, tz }: Props) => (
  <Container>
    <Headline>{title}</Headline>
    <Subheadline>{subtitle}</Subheadline>
    <Tz className="text-center">All timestamps and aggregations are shown in {tz}.</Tz>
    {description && <Description>{description}</Description>}
  </Container>
);

export default CoverPage;
